export default "__VITE_ASSET__abf76c15__"